import React from 'react';
import {connect} from 'react-redux';
import * as Actions from '../../../store/actions';
import {getLighterShade} from '../colorUtils';
import {InfoIcon} from '../InfoIcon';

const BusinessID = ({widgets: {singleApp}}) => {
  const baseColor = singleApp?.color || singleApp?.color_code || '#3f7cdb';

  const lighterShade = getLighterShade(baseColor, 90);

  const buttonStyle = {
    backgroundColor: baseColor,
  };

  const textColor = {
    color: baseColor,
  };

  const lighterBackgroundStyle = {
    backgroundColor: lighterShade,
  };

  return (
    <>
      <div className="mt-9 overflow-y-auto max-w-sm w-full px-6">
        {/* <div
          className="mx-auto w-fit px-2 pt-2 rounded-[10px] mb-3 text-center"
          style={lighterBackgroundStyle}
        >
          <span
            className="text-sm font-medium inline-flex items-center  "
            style={textColor}
          >
            <InfoIcon backgroundColor={baseColor} />
            To continue this on your smartphone.
            <span className="font-semibold ml-[2px]">Click here</span>
          </span>
        </div> */}

        <p className="text-center text-base font-medium text-[#1B2A4E] mb-3">
          Upload the CAC Document{' '}
        </p>

        <div className="h-[219px] border border-dashed rounded-[4px] border-brandBlue bg-customWhite flex items-center justify-center">
          <input
            type="file"
            id="file-upload"
            accept="image/jpeg, image/png, image/jpg, .pdf"
            className="hidden"
          />
          <p
            htmlFor="file-upload"
            className="text-sm text-center max-w-[160px]"
          >
            <span className="text-brandBlue cursor-pointer">
              {' '}
              Click here to select
            </span>{' '}
            from your device.
          </p>{' '}
        </div>
      </div>

      <div className="flex flex-col mt-4 px-6 justify-center items-center w-full max-w-sm gap-2">
        <button
          // style={buttonStyle}
          className="text-small !text-white font-medium h-12 rounded-lg w-full !bg-brandBlue"
          disabled
        >
          Upload
        </button>
        <button
          className="text-small !text-black rounded-lg font-medium h-12 bg-[#F9F9F9] w-full border border-[#333442]"
          disabled
        >
          <span>Capture Instead</span>
        </button>
      </div>
    </>
  );
};

export default connect(state => state, Actions)(BusinessID);
